import React from 'react';
import PageHeadline from './PageHeadline/PageHeadline';
import PageIngress from './PageIngress/PageIngress';
import PageRow from './PageRow/PageRow';
import PageTitle from './PageTitle/PageTitle';
import Element from '../Element/Element';
import { CreateProps } from '../../types/utils/CreateProps';

export type PageProps = CreateProps<
  {
    /** HTML tag name: div, span, h1 etc */
    tagName?: keyof JSX.IntrinsicElements;
  },
  typeof Element,
  'occupyVerticalSpace'
>;

const Page: React.FunctionComponent<PageProps> & {
  Headline: typeof PageHeadline;
  Title: typeof PageTitle;
  Ingress: typeof PageIngress;
  Row: typeof PageRow;
} = ({ children, tagName = 'div', ...props }) => (
  <Element tagName={tagName} occupyVerticalSpace {...props}>
    {children}
  </Element>
);

Page.Headline = PageHeadline;
Page.Title = PageTitle;
Page.Ingress = PageIngress;
Page.Row = PageRow;

export default Page;
